export default {
    description: "Description",
    orderingNote: "Note de commande"
}